import { h } from "preact";

import { classNames, renderIcon, stripKeys } from "../helpers";
import { Link } from "react-router-dom";
import { useEffect, useState } from "preact/hooks";

export default function ListItem({
  children,
  highlight,
  big,
  bold,
  bordered,
  iconOnTop,
  oneLine,
  ...props
}) {
  const [showHighlight, setShowHighlight] = useState(highlight);
  const labelFor = props.labelFor || null;
  let onClick = props.onClick;
  let TagType = "div";
  if (props.to) {
    TagType = Link;
  } else if (props.link) {
    TagType = "a";
  } else if (labelFor) {
    TagType = "label";
  }

  const linkProps = stripKeys(props, [
    "iconFront",
    "iconBack",
    "secondLine",
    "link",
  ]);

  if (props.link) {
    linkProps.target = "_blank";
    linkProps.rel = "noreferrer noopener";
    linkProps.download = props.download;
  }
  if (TagType === "div" && props.onClick) {
    TagType = "a";
    onClick = function (event) {
      event.preventDefault();
      props.onClick(event);
    };
  }

  useEffect(() => {
    if (showHighlight) {
      setTimeout(() => {
        setShowHighlight(false);
      }, 600);
    }
  }, []);

  return (
    <TagType
      {...linkProps}
      href={props.link || props.to}
      class={classNames(
        "listItem",
        (props.link || props.to || props.onClick) &&
          "listItem--withLink waves-effect waves-dark",
        props.class,
        big && "listItem--big",
        bold && "listItem--bold",
        bordered && "listItem--bordered",
        iconOnTop && "listItem--iconOnTop",
        oneLine && "listItem--oneLine",
        labelFor && "label--plain",
        showHighlight && "listItem--highlighted"
      )}
      for={labelFor}
      onClick={onClick}
      activeClassName="listItem--active"
    >
      {props.number ? (
        <span class="listItem__number">{props.number}</span>
      ) : (
        renderIcon(props.iconFront, "listItem__frontIcon")
      )}
      <span class={classNames("listItem__content", props.contentClass)}>
        {props.overline && (
          <span class="listItem__overline">{props.overline}</span>
        )}
        {bold ? <strong>{children}</strong> : children}
        {props.secondLine && (
          <span class="listItem__secondary">{props.secondLine}</span>
        )}
      </span>
      {renderIcon(props.iconBack, "listItem__backIcon")}
    </TagType>
  );
}
